export const getLetterUser = (nom_usage: string): string => {
  return nom_usage.substring(0, 1);
};
